module.exports = __webpack_public_path__ + "static/media/green_popup.5a6c0e83.png";